import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

let cache = null;

export function useBilling() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/billing`).then((r) => { cache = r.data; setB(r.data); }).catch(() => {});
  }, []);
  return b;
}

export const resetBilling = () => { cache = null; };
